var map = {
	"./alerts.svg": 2561,
	"./arrow-button.svg": 4716,
	"./arrow-downward.svg": 8074,
	"./arrow-thin.svg": 4969,
	"./arrow.svg": 1423,
	"./attachment.svg": 7483,
	"./avatar.svg": 5079,
	"./card.svg": 8662,
	"./chat.svg": 1822,
	"./check-circle-for-animation.svg": 8702,
	"./check-circle-small.svg": 1467,
	"./check-circle.svg": 3289,
	"./check-email.svg": 4939,
	"./check-for-animation.svg": 6643,
	"./check-phone.svg": 6603,
	"./check-thin.svg": 5676,
	"./check.svg": 2396,
	"./checkbox.svg": 8095,
	"./checkmark.svg": 9935,
	"./chevron-big-right.svg": 7977,
	"./chevron-down.svg": 1754,
	"./clock.svg": 1374,
	"./close-modal.svg": 8456,
	"./comments-circle-black.svg": 1529,
	"./comments-circle.svg": 5919,
	"./delete.svg": 9226,
	"./download-portal.svg": 7467,
	"./download.svg": 2460,
	"./edit.svg": 1680,
	"./error-label.svg": 8319,
	"./error-large.svg": 8428,
	"./error.svg": 5070,
	"./external-link-bold.svg": 8026,
	"./external-link-extra-small.svg": 2921,
	"./external-link-small.svg": 5764,
	"./external-link.svg": 1086,
	"./facebook-icon.svg": 154,
	"./facebook.svg": 536,
	"./floor-plan.svg": 3910,
	"./hamburger.svg": 8577,
	"./hand-pointing-1.svg": 6436,
	"./hand-pointing-2.svg": 887,
	"./hand-thumb-up.svg": 310,
	"./info.svg": 6936,
	"./instagram.svg": 5040,
	"./linkedin.svg": 8458,
	"./location.svg": 4737,
	"./lock-unlocked.svg": 8989,
	"./lock.svg": 1049,
	"./mail.svg": 5513,
	"./man-pc-small.svg": 5988,
	"./membershipcard-thin.svg": 118,
	"./minus.svg": 3372,
	"./nets-payment.svg": 5405,
	"./new-window.svg": 7471,
	"./padlock.svg": 8229,
	"./phone.svg": 3392,
	"./plus-bold.svg": 2956,
	"./plus-circle.svg": 6497,
	"./plus-small.svg": 9734,
	"./plus.svg": 548,
	"./search-small.svg": 4938,
	"./search.svg": 5768,
	"./trash.svg": 9242,
	"./upload.svg": 7183,
	"./vipps-payment.svg": 787,
	"./vipps.svg": 7470,
	"./x-circle.svg": 6065,
	"./x.svg": 8596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;